let $interval: any = "";

let $store: any = "";

export default {
  setUpPollingTasks(store) {
    $store = store;
    this.clearPollingTasks();

    $interval = setInterval(() => {
      const isLogged = $store.getters["auth/isLogged"];
      if (isLogged) {
        $store.dispatch("wallet/mixin/loadAssets");
        $store.dispatch("hfox/loadBalance");
        $store.dispatch("trade/loadFiatPairs");
        $store.dispatch("trade/loadPairs");
        $store.dispatch("market/loadProcessOrder");
      }
    }, 10000);
  },

  clearPollingTasks() {
    clearInterval($interval);
  }
};
